import $ from 'jquery';
class Offices {
	constructor(element) {
		this.url = '';
		$(document).ready(() => this.load());
		// $(window).scroll(() => this.centerMap());
	}

	load() {
		if($('.twz-element-offices__map').length) {
			this.initMap();
		}
	}

	initMap() {

		// Find marker elements within map.
		this.markers = $('.twz-element-offices__map').find('.marker');

		// Create gerenic map.
		var mapArgs = {
			center		: {lat:$(this.markers[0]).data('lat'),lng:$(this.markers[0]).data('lng')},
			zoom        : $('.twz-element-offices__map').data('zoom') || 3,
			mapTypeId   : google.maps.MapTypeId.ROADMAP
		};
		this.map = new google.maps.Map( $('.twz-element-offices__map')[0], mapArgs );

		// Add markers.
		this.map.markers = [];
		this.initMarkers();

		// Center map based on markers.
		// this.centerMap();
	}

	initMarkers() {

		this.markers.each((index,el) => {
			var lat = $(el).data('lat');
			var lng = $(el).data('lng');
			var latLng = {
				lat: parseFloat( lat ),
				lng: parseFloat( lng )
			};

			// Create marker instance.
			var marker = new google.maps.Marker({
				position : latLng,
				map: this.map,
				icon: {
					url: $(el).data('markerimage'),
					size: new google.maps.Size(40,50),
					// origin: new google.maps.Point(0, 0),
					// anchor: new google.maps.Point(0, 0),
					// scaledSize: new google.maps.Size(47, 63)
				}
			});

			// Append to reference for later use.
			this.map.markers.push( marker );

			// If marker contains HTML, add it to an infoWindow.
			if( $(el).html() ){

				// Create info window.
				var infowindow = new google.maps.InfoWindow({
					content: $(el).html()
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', () => {
					infowindow.open( this.map, marker );
				});
			}
		})

	}

	centerMap () {

		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		this.map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if( this.map.markers.length == 1 ){
			this.map.setCenter( bounds.getCenter() );
		} else{
			this.map.fitBounds( bounds );
		}
	}
}

new Offices